import React from "react";
import Logo from "../../elements/logo/Logo";
import Nav from "../../common/header/Nav";
import StickyHeader from "./StickyHeader";
import { Link } from "react-router-dom";
import SwitcherHeader from "../../elements/switcher/SwitcherHeader";
import MobileMenu from "./MobileMenu";
import { useSelector } from "react-redux";

const HeaderFour = () => {
  const sticky = StickyHeader(100);
  const {currentCustomer} = useSelector(state => state.store);
  const MobileMenuHandler = () => {
    document.querySelector(".mobilemenu-popup").classList.toggle("show");
    document.querySelector("body").classList.toggle("mobilemenu-show");

    var elements = document.querySelectorAll(
      ".mobilemenu-popup .menu-item-has-children > a"
    );

    for (var i in elements) {
      if (elements.hasOwnProperty(i)) {
        elements[i].onclick = function () {
          this.parentElement
            .querySelector(".gc-submenu")
            .classList.toggle("active");
          this.classList.toggle("open");
        };
      }
    }
  };

  return (
    <>
      <header className="header gc-header header-style-3">
        <div className={`gc-mainmenu ${sticky ? "gc-sticky" : ""}`}>
          <div className="container">
            <div className="header-navbar">
              <div className="header-logo">
                <Logo
                  limage={window["logo_white"]}
                  dimage={window["logo_black"]}
                  simage={window["logo_white"]}
                />
              </div>
              <div className="header-main-nav">
                <Nav />
              </div>
              {/* <div className="header-action">
                <ul className="list-unstyled">
                  <li className="header-btn">
                    <Link
                      to={process.env.PUBLIC_URL + "/contact"}
                      className="gc-btn btn-fill-white"
                    >
                      Let's Talk
                    </Link>
                  </li>
                  <li className="mobile-menu-btn sidemenu-btn d-lg-none d-block">
                    <button className="btn-wrap" onClick={MobileMenuHandler}>
                      <span></span>
                      <span></span>
                      <span></span>
                    </button>
                  </li>
                  <li className="my_switcher d-block d-lg-none">
                    <SwitcherHeader />
                  </li>
                </ul>
              </div> */}
              <div className="header-action">
                <ul className="list-unstyled">
                  <li className="buy-btn">
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      // href={window["APP_HOME"]}
                      className="gc-btn btn-gradient-purple"
                      onClick={() => {
                        window.open(
                          `https://${window.location.host}${window["APP_HOME"]}`,
                          "_blank"
                        );
                      }}
                    >
                     {currentCustomer?.apps_config?.systemName || "Gobierno Electrónico"}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
      <MobileMenu MobileHandler={MobileMenuHandler} />
    </>
  );
};

export default HeaderFour;
